webpackJsonp([77],{

/***/ 2429:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FoodDetail_vue__ = __webpack_require__(3579);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0db10fd5_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FoodDetail_vue__ = __webpack_require__(4202);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(4196)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0db10fd5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FoodDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0db10fd5_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FoodDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/webapp/patient/foods/FoodDetail.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0db10fd5", Component.options)
  } else {
    hotAPI.reload("data-v-0db10fd5", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 2572:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MICROHABIT_SIMPLE_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MICROHABIT_FOOD_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MICROHABIT_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return MICROHABIT_TYPE_NAMES; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
var _MICROHABIT_TYPE_NAME;var MICROHABIT_SIMPLE_TYPE=1;var MICROHABIT_FOOD_TYPE=2;var MICROHABIT_TYPES=[MICROHABIT_SIMPLE_TYPE,MICROHABIT_FOOD_TYPE];var MICROHABIT_TYPE_NAMES=(_MICROHABIT_TYPE_NAME={},__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_MICROHABIT_TYPE_NAME,MICROHABIT_SIMPLE_TYPE,'microhabits'),__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_MICROHABIT_TYPE_NAME,MICROHABIT_FOOD_TYPE,'foods'),_MICROHABIT_TYPE_NAME);/* unused harmony default export */ var _unused_webpack_default_export = ({MICROHABIT_SIMPLE_TYPE:MICROHABIT_SIMPLE_TYPE,MICROHABIT_FOOD_TYPE:MICROHABIT_FOOD_TYPE});

/***/ }),

/***/ 2649:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(1291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(25);
var api=function api(){return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].prototype.$api;};var MicrohabitRepository=function(){function MicrohabitRepository(type){__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this,MicrohabitRepository);this.type=type;}__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(MicrohabitRepository,[{key:'getMicrohabitCategory',value:function getMicrohabitCategory(categoryId){return api().get(Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* path */])('microhabits/categories')+'/'+categoryId);}},{key:'getMicrohabitCategories',value:function getMicrohabitCategories(){return api().get(Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* path */])('microhabits/categories'),{params:{type:this.type}});}},{key:'getMicrohabit',value:function getMicrohabit(microhabitId){return api().get(Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* path */])('microhabits')+'/'+microhabitId);}},{key:'getMicrohabits',value:function getMicrohabits(){var category=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;return api().get(''+Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* path */])('microhabits'),{params:{categoryId:category,type:this.type}});}},{key:'getPatientMicrohabits',value:function getPatientMicrohabits(){var categoryId=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var microhabitId=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;return api().get(''+Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* path */])('patient/microhabits'),{params:{categoryId:categoryId,microhabitId:microhabitId,type:this.type}});}},{key:'addPatientMicrohabit',value:function addPatientMicrohabit(patientMicrohabit){patientMicrohabit.type=this.type;return api().post(''+Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* path */])('patient/microhabits'),patientMicrohabit);}},{key:'updatePatientMicrohabit',value:function updatePatientMicrohabit(patientMicrohabit){patientMicrohabit.type=this.type;return api().put(''+Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* path */])('patient/microhabits'),patientMicrohabit);}},{key:'deletePatientMicrohabit',value:function deletePatientMicrohabit(patientMicrohabitId){var deleteHabit=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;return api().delete(Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* path */])('patient/microhabits')+'/'+patientMicrohabitId,{params:{deleteHabit:deleteHabit,type:this.type}});}}]);return MicrohabitRepository;}();/* harmony default export */ __webpack_exports__["a"] = (MicrohabitRepository);

/***/ }),

/***/ 3579:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_base_forms_BaseCheckbox__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_utils_ImagesTransition__ = __webpack_require__(4198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_views_healthy_habits_HealthyHabitsForm__ = __webpack_require__(1294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_base_BaseDialog__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_microhabitTypes__ = __webpack_require__(2572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__repositories_MicrohabitsRepository__ = __webpack_require__(2649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_base_buttons_ArrowButton__ = __webpack_require__(227);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










var COOKIE_FOOD_DETAILS_DIALOG = 'food-details-dialog';

/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		BCarousel: __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["g" /* BCarousel */],
		BCarouselSlide: __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["h" /* BCarouselSlide */],
		BIconHeart: __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["Y" /* BIconHeart */],
		BModal: __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["_32" /* BModal */],
		BButton: __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["d" /* BButton */],
		BaseCheckbox: __WEBPACK_IMPORTED_MODULE_2__components_base_forms_BaseCheckbox__["default"],
		BIconHeartFill: __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["Z" /* BIconHeartFill */],
		ImagesTransition: __WEBPACK_IMPORTED_MODULE_3__components_utils_ImagesTransition__["a" /* default */],
		HealthyHabitsForm: __WEBPACK_IMPORTED_MODULE_4__components_views_healthy_habits_HealthyHabitsForm__["a" /* default */],
		BIconChevronRight: __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["Q" /* BIconChevronRight */],
		BIconChevronLeft: __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["P" /* BIconChevronLeft */],
		BIconBell: __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["G" /* BIconBell */],
		BIconBellFill: __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["H" /* BIconBellFill */],
		BAlert: __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["a" /* BAlert */],
		BBadge: __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["b" /* BBadge */],
		BIconPlusCircle: __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["_7" /* BIconPlusCircle */],
		BIconDashCircle: __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["S" /* BIconDashCircle */],
		BaseDialog: __WEBPACK_IMPORTED_MODULE_5__components_base_BaseDialog__["default"],
		ArrowButton: __WEBPACK_IMPORTED_MODULE_8__components_base_buttons_ArrowButton__["a" /* default */]
	},
	data: function data() {
		return {
			COOKIE_FOOD_DETAILS_DIALOG: COOKIE_FOOD_DETAILS_DIALOG,
			food: null,
			patientFood: {},
			newPatientFood: {
				createHabit: false,
				inDiet: false,
				habitId: null
			},
			addPatientFoodModalVisible: false,
			deletePatientFoodModalVisible: false,
			deleteAlsoFromHabits: false,
			showFoodDetailsDialog: true
		};
	},

	methods: {
		onHeartIconClick: function onHeartIconClick() {
			if (!this.$store.getters['session/userHasCompanies']) {
				this.$store.dispatch('showOnlySubscriptorsDialog');
				return;
			}
			if (this.foodIsInPatientFoods) {
				this.deletePatientFoodModalVisible = true;
			} else {
				this.addPatientFood();
				/* this.addPatientFoodModalVisible = true */
			}
		},
		onBellIconClick: function onBellIconClick() {
			if (this.foodHasCreatedHabit) {
				this.$helpers.goToHabits();
			} else {
				this.newPatientFood.createHabit = true;
				this.addPatientFoodModalVisible = true;
			}
		},
		onPlusIconClick: function onPlusIconClick() {
			if (this.patientFood.inDiet) {
				this.removeFoodFromDiet();
			} else {
				this.addFoodToDiet();
			}
		},
		addPatientFood: function addPatientFood() {
			var _this = this;

			this.newPatientFood.microhabitId = this.food.id;
			this.newPatientFood.microhabitCategoryId = this.$route.params.category;
			this.repository.addPatientMicrohabit(this.newPatientFood).then(function (response) {
				_this.addPatientFoodModalVisible = false;
				_this.patientFood = _this.newPatientFood;
				_this.patientFood.id = response.data;
				_this.newPatientFood = {};
				_this.$store.dispatch('showAlert', { text: _this.$t('patient.foods.patient-food-add-success'), variant: 'success' });
			});
		},
		deleteFoodFromPatientFoods: function deleteFoodFromPatientFoods() {
			var _this2 = this;

			this.repository.deletePatientMicrohabit(this.patientFood.id, this.deleteAlsoFromHabits).then(function () {
				_this2.patientFood = {};
				_this2.deletePatientFoodModalVisible = false;
				_this2.$store.dispatch('showAlert', { text: _this2.$t('patient.foods.patient-food-delete-success'), variant: 'success' });
			});
		},
		removeFoodFromDiet: function removeFoodFromDiet() {
			var _this3 = this;

			this.patientFood.inDiet = false;
			this.repository.updatePatientMicrohabit(this.patientFood).then(function () {
				_this3.deletePatientFoodModalVisible = false;
				_this3.$store.dispatch('showAlert', { text: _this3.$t('patient.foods.patient-food-remove-diet-success'), variant: 'success' });
			});
		},
		onNewHabitCreated: function onNewHabitCreated(habitId) {
			var _this4 = this;

			if (this.foodIsInPatientFoods) {
				this.patientFood.habitId = habitId;
				this.repository.updatePatientMicrohabit(this.patientFood).then(function () {
					_this4.$store.dispatch('showAlert', { text: _this4.$t('patient.foods.habit-created-success-on-modify'), variant: 'success' });
					_this4.addPatientFoodModalVisible = false;
				});
			} else {
				this.newPatientFood.habitId = habitId;
			}
		},
		goToSlide: function goToSlide() {
			var _this5 = this;

			var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

			this.repository.getMicrohabits(this.$route.params.category).then(function (response) {
				var foods = response.data;
				var currentIndex = foods.findIndex(function (food) {
					return food.id === _this5.food.id;
				});
				var newIndex = currentIndex + direction;
				if (newIndex === -1) {
					newIndex = foods.length - 1;
				} else if (newIndex > foods.length - 1) {
					newIndex = 0;
				}
				_this5.$router.push({ name: 'FoodDetail', params: { category: _this5.$route.params.category, food: foods[newIndex].id } });
			});
		},
		addFoodToDiet: function addFoodToDiet() {
			var _this6 = this;

			this.patientFood.inDiet = true;
			this.repository.updatePatientMicrohabit(this.patientFood).then(function () {
				_this6.$store.dispatch('showAlert', { text: _this6.$t('patient.foods.patient-food-add-diet-success'), variant: 'success' });
			});
		}
	},
	computed: {
		getCurrentFoodDescription: function getCurrentFoodDescription() {
			var _this7 = this;

			return this.food && this.food.categories ? this.food.categories.find(function (category) {
				return category.id === _this7.$route.params.category;
			}).description : null;
		},
		addToFavoritesTooltip: function addToFavoritesTooltip() {
			return !this.foodIsInPatientFoods ? this.$t('patient.foods.add-to-my-foods') : this.$t('patient.foods.remove-from-my-foods');
		},
		foodIsInPatientFoods: function foodIsInPatientFoods() {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.patientFood).length > 0;
		},
		foodHasCreatedHabit: function foodHasCreatedHabit() {
			return this.patientFood.habitId;
		},
		heartIconComponentType: function heartIconComponentType() {
			return this.foodIsInPatientFoods ? 'BIconHeartFill' : 'BIconHeart';
		},
		bellIconComponentType: function bellIconComponentType() {
			return this.foodHasCreatedHabit ? 'BIconBellFill' : 'BIconBell';
		},
		plusIconComponentType: function plusIconComponentType() {
			return this.patientFood && this.patientFood.achieved ? 'BIconDashCircle' : 'BIconPlusCircle';
		},
		createHabitTooltip: function createHabitTooltip() {
			return this.foodHasCreatedHabit ? this.$t('patient.foods.go-to-habit') : this.$t('patient.foods.create-habit');
		},
		plusIconTooltip: function plusIconTooltip() {
			return this.patientFood.achieved ? this.$t('patient.foods.remove-from-diet') : this.$t('patient.foods.diet-question');
		},
		habitCreationVisible: function habitCreationVisible() {
			return this.newPatientFood && !this.newPatientFood.habitId;
		},
		modalTitle: function modalTitle() {
			return this.foodIsInPatientFoods ? this.$t('patient.foods.habits-question') : this.$t('patient.foods.add-to-my-foods');
		},
		repository: function repository() {
			return new __WEBPACK_IMPORTED_MODULE_7__repositories_MicrohabitsRepository__["a" /* default */](__WEBPACK_IMPORTED_MODULE_6__constants_microhabitTypes__["a" /* MICROHABIT_FOOD_TYPE */]);
		}
	},
	mounted: function mounted() {
		var _this8 = this;

		this.repository.getMicrohabit(this.$route.params.food).then(function (response) {
			_this8.food = response.data;
			_this8.$store.commit('microhabits/setCurrentMicrohabit', _this8.food);
		});
		if (this.$store.getters['session/userHasCompanies']) {
			this.repository.getPatientMicrohabits(this.$route.params.category, this.$route.params.food).then(function (response) {
				_this8.patientFood = response.data && response.data[0] ? response.data[0] : {};
			});
		}

		if (this.$route.query.reminder) {
			this.onBellIconClick();
		}
	}
});

/***/ }),

/***/ 3580:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'ImagesTransition',
	data: function data() {
		return {
			currentImage: 0
		};
	},

	props: {
		images: {
			type: Array,
			required: true
		},
		transitionDuration: {
			type: Number,
			default: 3000
		}
	},
	mounted: function mounted() {
		var _this = this;

		setInterval(function () {
			_this.currentImage = (_this.currentImage + 1) % _this.images.length;
		}, this.transitionDuration);
	}
});

/***/ }),

/***/ 4196:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4197);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("33421506", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-0db10fd5\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./FoodDetail.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-0db10fd5\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./FoodDetail.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 4197:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale[data-v-0db10fd5]{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active[data-v-0db10fd5],.slide-down-leave-active[data-v-0db10fd5]{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter[data-v-0db10fd5],.slide-down-leave-to[data-v-0db10fd5]{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active[data-v-0db10fd5],.slide-fade-left-leave-active[data-v-0db10fd5]{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter[data-v-0db10fd5],.slide-fade-left-leave-to[data-v-0db10fd5]{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active[data-v-0db10fd5]{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter[data-v-0db10fd5],.fade-leave-to[data-v-0db10fd5]{opacity:0\n}\nh3[data-v-0db10fd5]{text-transform:uppercase\n}\n[data-v-0db10fd5] #carousel-food{display:-webkit-box;display:-ms-flexbox;display:flex;margin:auto\n}\n@media only screen and (min-width: 1024px){\n[data-v-0db10fd5] #carousel-food{width:70%;height:300px\n}\n}\n[data-v-0db10fd5] .food-slide img{width:100%;-o-object-fit:cover;object-fit:cover\n}\n.neu-card-food[data-v-0db10fd5]{background-color:#eee;border-radius:23px;-webkit-box-shadow:-10px -10px 35px #fff,10px 10px 35px rgba(13,39,80,0.160784);box-shadow:-10px -10px 35px #fff,10px 10px 35px rgba(13,39,80,0.160784);padding:2rem;margin-top:20px\n}\n.heart-food[data-v-0db10fd5]{position:absolute;top:2rem;cursor:pointer;font-size:2rem;right:2rem\n}\n.bell-food[data-v-0db10fd5]{position:absolute;top:2rem;cursor:pointer;font-size:2rem;left:2rem\n}\n.add-to-diet[data-v-0db10fd5]{position:absolute;top:2rem;cursor:pointer;font-size:2rem;right:6rem\n}\n.chevron-icons[data-v-0db10fd5]{cursor:pointer;position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%, -50%);transform:translate(-50%, -50%)\n}\n", ""]);

// exports


/***/ }),

/***/ 4198:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImagesTransition_vue__ = __webpack_require__(3580);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ae171f8a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImagesTransition_vue__ = __webpack_require__(4201);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(4199)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ae171f8a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImagesTransition_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ae171f8a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImagesTransition_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/utils/ImagesTransition.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-ae171f8a", Component.options)
  } else {
    hotAPI.reload("data-v-ae171f8a", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 4199:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4200);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("0e0b949a", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-ae171f8a\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ImagesTransition.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-ae171f8a\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ImagesTransition.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 4200:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale[data-v-ae171f8a]{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active[data-v-ae171f8a],.slide-down-leave-active[data-v-ae171f8a]{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter[data-v-ae171f8a],.slide-down-leave-to[data-v-ae171f8a]{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active[data-v-ae171f8a],.slide-fade-left-leave-active[data-v-ae171f8a]{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter[data-v-ae171f8a],.slide-fade-left-leave-to[data-v-ae171f8a]{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active[data-v-ae171f8a]{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter[data-v-ae171f8a],.fade-leave-to[data-v-ae171f8a]{opacity:0\n}\n.fade-enter-active[data-v-ae171f8a],.fade-leave-active[data-v-ae171f8a]{-webkit-transition:opacity 1s ease;transition:opacity 1s ease\n}\n.fade-enter[data-v-ae171f8a],.fade-leave-to[data-v-ae171f8a]{opacity:0\n}\nimg[data-v-ae171f8a]{width:100%;height:300px;-o-object-fit:cover;object-fit:cover;-o-object-position:center;object-position:center;border-radius:23px;position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%, -50%);transform:translate(-50%, -50%)\n}\ndiv[data-v-ae171f8a]{width:100%;height:300px;position:relative\n}\n", ""]);

// exports


/***/ }),

/***/ 4201:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("transition", { attrs: { name: "fade", mode: "out-in" } }, [
        _c("div", [
          _c("img", {
            key: _vm.images[_vm.currentImage],
            attrs: {
              src: _vm.images[_vm.currentImage],
              alt: "transitioning image"
            }
          })
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ae171f8a", esExports)
  }
}

/***/ }),

/***/ 4202:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.food
    ? _c(
        "div",
        [
          _vm.$store.getters["session/userHasCompanies"]
            ? _c(
                "base-dialog",
                {
                  attrs: {
                    dontShowAgainCookie: _vm.COOKIE_FOOD_DETAILS_DIALOG,
                    dontShowAgainCookieExpirationDays: 30
                  },
                  model: {
                    value: _vm.showFoodDetailsDialog,
                    callback: function($$v) {
                      _vm.showFoodDetailsDialog = $$v
                    },
                    expression: "showFoodDetailsDialog"
                  }
                },
                [
                  _c("p", [
                    _vm._v(
                      _vm._s(_vm.$t("patient.foods.food-detail-dialog-info"))
                    )
                  ])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "BModal",
            {
              attrs: {
                title: _vm.modalTitle,
                "hide-header": "",
                "hide-footer": "",
                centered: ""
              },
              model: {
                value: _vm.addPatientFoodModalVisible,
                callback: function($$v) {
                  _vm.addPatientFoodModalVisible = $$v
                },
                expression: "addPatientFoodModalVisible"
              }
            },
            [
              _c(
                "div",
                { staticClass: "text-center" },
                [
                  !_vm.foodIsInPatientFoods
                    ? _c(
                        "base-checkbox",
                        {
                          model: {
                            value: _vm.newPatientFood.inDiet,
                            callback: function($$v) {
                              _vm.$set(_vm.newPatientFood, "inDiet", $$v)
                            },
                            expression: "newPatientFood.inDiet"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("patient.foods.diet-question")))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.habitCreationVisible
                    ? _c(
                        "div",
                        [
                          !_vm.foodIsInPatientFoods
                            ? _c(
                                "base-checkbox",
                                {
                                  model: {
                                    value: _vm.newPatientFood.createHabit,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.newPatientFood,
                                        "createHabit",
                                        $$v
                                      )
                                    },
                                    expression: "newPatientFood.createHabit"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("patient.foods.habits-question")
                                    )
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.newPatientFood &&
                          _vm.newPatientFood.createHabit &&
                          !_vm.newPatientFood.habitId
                            ? _c(
                                "div",
                                [
                                  _c("healthy-habits-form", {
                                    attrs: {
                                      inModal: "",
                                      habitDescription: _vm.$i18nHelpers.normalize(
                                        _vm.food.name
                                      )
                                    },
                                    on: {
                                      habitCreated: function(habitId) {
                                        return _vm.onNewHabitCreated(habitId)
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.newPatientFood.habitId
                    ? _c(
                        "div",
                        [
                          _c(
                            "b-alert",
                            { attrs: { show: "", variant: "success" } },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("patient.foods.habit-created-success")
                                )
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.foodIsInPatientFoods
                    ? _c(
                        "b-button",
                        {
                          staticClass: "mt-4",
                          attrs: { variant: "primary" },
                          on: { click: _vm.addPatientFood }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("patient.foods.add-to-my-foods"))
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "BModal",
            {
              attrs: { "hide-header": "", "hide-footer": "", centered: "" },
              model: {
                value: _vm.deletePatientFoodModalVisible,
                callback: function($$v) {
                  _vm.deletePatientFoodModalVisible = $$v
                },
                expression: "deletePatientFoodModalVisible"
              }
            },
            [
              _c(
                "div",
                { staticClass: "text-center" },
                [
                  _c("p", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("patient.foods.remove-from-my-foods-warning")
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _vm.foodHasCreatedHabit
                    ? _c(
                        "base-checkbox",
                        {
                          model: {
                            value: _vm.deleteAlsoFromHabits,
                            callback: function($$v) {
                              _vm.deleteAlsoFromHabits = $$v
                            },
                            expression: "deleteAlsoFromHabits"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("patient.foods.remove-from-habits"))
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "danger" },
                      on: { click: _vm.deleteFoodFromPatientFoods }
                    },
                    [_vm._v(_vm._s(_vm.$t("patient.foods.delete-food")))]
                  ),
                  _vm._v(" "),
                  _vm.patientFood.inDiet
                    ? _c(
                        "b-button",
                        {
                          attrs: { variant: "info" },
                          on: { click: _vm.removeFoodFromDiet }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("patient.foods.remove-from-diet"))
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { cols: "1" } },
                [
                  _c("b-icon-chevron-left", {
                    staticClass: "chevron-icons",
                    attrs: { size: "2rem" },
                    on: {
                      click: function($event) {
                        return _vm.goToSlide(-1)
                      }
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "10" } },
                [
                  _c(
                    "b-row",
                    {
                      staticClass:
                        "neu-card-food text-center w-100 position-relative",
                      attrs: { cols: "12", "cols-xl": "12" }
                    },
                    [
                      _c("h3", { staticClass: "m-auto d-block w-100" }, [
                        _vm._v(
                          _vm._s(_vm.$i18nHelpers.normalize(_vm.food.name))
                        )
                      ]),
                      _vm._v(" "),
                      _vm.$store.getters["session/userHasCompanies"] &&
                      _vm.foodIsInPatientFoods
                        ? _c(_vm.bellIconComponentType, {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover",
                                value: _vm.createHabitTooltip,
                                expression: "createHabitTooltip",
                                modifiers: { hover: true }
                              }
                            ],
                            tag: "component",
                            staticClass: "position-absolute bell-food",
                            attrs: { variant: "primary" },
                            on: { click: _vm.onBellIconClick }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.$store.getters["session/userHasCompanies"]
                        ? _c(_vm.heartIconComponentType, {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover",
                                value: _vm.addToFavoritesTooltip,
                                expression: "addToFavoritesTooltip",
                                modifiers: { hover: true }
                              }
                            ],
                            tag: "component",
                            staticClass: "position-absolute heart-food",
                            attrs: { variant: "primary" },
                            on: { click: _vm.onHeartIconClick }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("ImagesTransition", {
                        staticClass: "mt-5",
                        attrs: { images: _vm.food.images }
                      }),
                      _vm._v(" "),
                      _c("h5", { staticClass: "mt-5" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$i18nHelpers.normalize(
                              _vm.getCurrentFoodDescription
                            )
                          )
                        )
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "pt-3" },
                    [
                      _vm.$store.getters["session/userHasCompanies"]
                        ? _c("ArrowButton", {
                            staticClass: "ml-auto",
                            attrs: {
                              variant: "primary",
                              action: function() {
                                _vm.$router.push({ name: "FavoritesFood" })
                              },
                              text: _vm.$t("patient.foods.go-to-my-foods")
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "1" } },
                [
                  _c("b-icon-chevron-right", {
                    staticClass: "chevron-icons",
                    attrs: { size: "5rem" },
                    on: {
                      click: function($event) {
                        return _vm.goToSlide(1)
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0db10fd5", esExports)
  }
}

/***/ })

});


// WEBPACK FOOTER //
// static-appopensalud/js/77.041ca3abfb00898e459d.js